"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _utils = require("../utils/utils");

var _default = {
  title: 'Cube Type',
  isRelevant: function isRelevant(styleParams) {
    return styleParams.cubeImages;
  },
  type: _constants.INPUT_TYPES.OPTIONS,
  "default": _constants.GALLERY_CONSTS.cubeType.CROP,
  options: (0, _utils.createOptions)('cubeType'),
  description: "Choose between croping the image to fill it's container (\"fill\") or fiting the whole image (\"fit\").\n  "
};
exports["default"] = _default;